var _module = require('../../module');

_module.component('affiliateBranding', {
    bindings: {
        affiliate: '<'
    },
    controllerAs: 'affiliateBranding',
    controller: [
        '$log',

        function affiliateBrandingCtrl($log) {
            var _this = this;
        }
    ],
    template: require('./index.html')
});
